module.exports = __webpack_public_path__ + "dist/assets/redesign/ui/components/tips-modal/img/tips-bulb__5699738f76a7e734c3c52bcb28e0f74c.png";